import { Component, OnInit, ViewChild, Injector, ElementRef, Output, EventEmitter } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ActivatedRoute, Router } from "@angular/router";
import {
    SalesTrackingServiceProxy,
} from '@shared/service-proxies/service-proxies';

@Component({
    selector: 'detailDocument',
    template: ``,
})
export class DetailDocumentComponent extends AppComponentBase {
    params;
    base64String;
    fileType;

    constructor(
        injector: Injector,
        private _activeroute: ActivatedRoute,
        private _salesTrackingService: SalesTrackingServiceProxy,
    ) {
        super(injector);
    }

    ngOnInit() {
        this._activeroute.params.subscribe(params => {
            debugger
            if (params != undefined) {
                this.params = params;
                this.getDocumentKPRFile(params.psCode, params.bookingHeaderID, params.documentType, params.priorityPassID);
            }
        });
    }

    getDocumentKPRFile(_psCode, _bookingHeaderID, _documentType, _priorityPassID) {
        debugger
        this._salesTrackingService.getDocumentKPRFile(_psCode, _bookingHeaderID, _documentType, _priorityPassID)
            .subscribe(result => {
                if (result.documentType.toLowerCase().includes("image")) {
                    this.base64String = ("data:image/png;base64," + result.documentFile);

                    let obj = document.createElement('img');
                    obj.src = this.base64String;
                    obj.title = this.params.documentType;
                    obj.alt = this.params.documentType;
                    obj.style.width = 'fit-content';
                    obj.style.height = 'fit-content';
                    obj.style.position = 'absolute';
                    document.body.appendChild(obj);
                }
                if (result.documentType.toLowerCase().includes("pdf")) {
                    this.base64String = ("data:application/pdf;base64," + result.documentFile);

                    // Convert base64 to binary
                    const binaryData = atob(result.documentFile);

                    // Create a Uint8Array from the binary data
                    const arrayBuffer = new Uint8Array(binaryData.length);
                    for (let i = 0; i < binaryData.length; i++) {
                        arrayBuffer[i] = binaryData.charCodeAt(i);
                    }

                    // Create a Blob from the Uint8Array
                    const blob = new Blob([arrayBuffer], { type: 'application/pdf' });

                    // Create an object element and set its properties
                    let obj = document.createElement('object');
                    obj.style.width = '100%';
                    obj.style.height = '100%';
                    obj.type = 'application/pdf';

                    // Set the object element's data to the Blob
                    obj.data = URL.createObjectURL(blob);

                    // Append the object element to the body
                    document.body.appendChild(obj);
                }
                this.fileType = result.documentType;
                //     this.base64String = ("data:application/pdf;base64," + result.documentFile);

                //     let obj = document.createElement('object');
                //     obj.style.width = '100%';
                //     obj.style.height = '100%';
                //     obj.type = 'application/pdf';
                //     obj.data = this.base64String;
                //     document.body.appendChild(obj);
                // }
                // this.fileType = result.documentType;
            }, err => {
                console.error(err)
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/sales-tracking/step-6-actions/detail-document.component.ts